<template>
  <div
    class="sidebar shadow-3 d-print-none"
    :class="{'active': showMenu}"
  >
    <div class="sidebar-wrapper">
      <div class="logo d-flex pl-3 align-items-center">
        <router-link
          :to="'/'"
          class="brand"
        >Eros</router-link>
      </div>

      <ul class="nav">
        <li class="nav-item">
          <router-link
            class="nav-link"
            to="/products"
          >
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 24 24"
              xml:space="preserve"
              width="24"
              height="24"
            >
              <g
                class="nc-icon-wrapper"
                transform="translate(0.5, 0.5)"
                fill="#ffffff"
              >
                <rect
                  x="3"
                  y="9"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  width="18"
                  height="14"
                  stroke-linejoin="round"
                ></rect>
                <line
                  data-color="color-2"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  x1="5"
                  y1="5"
                  x2="19"
                  y2="5"
                  stroke-linejoin="round"
                ></line>
                <line
                  data-color="color-2"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  x1="8"
                  y1="1"
                  x2="16"
                  y2="1"
                  stroke-linejoin="round"
                ></line>
                <polyline
                  data-color="color-2"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  points=" 16,14 16,16 8,16 8,14 "
                  stroke-linejoin="round"
                ></polyline>
              </g>
            </svg>
            <span>
              Artigos
            </span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            to="/stocks"
          >
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 24 24"
              xml:space="preserve"
              width="24"
              height="24"
            >
              <g
                class="nc-icon-wrapper"
                transform="translate(0.5, 0.5)"
                fill="#ffffff"
              >
                <polyline
                  data-color="color-2"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  points=" 8,5 8,1 16,1 16,5 "
                  stroke-linejoin="round"
                ></polyline>
                <polyline
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  points="9,15 1,15 1,5 23,5 23,15 15,15 "
                  stroke-linejoin="round"
                ></polyline>
                <polyline
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  points="22,18 22,23 2,23 2,18 "
                  stroke-linejoin="round"
                ></polyline>
                <rect
                  data-color="color-2"
                  x="9"
                  y="13"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  width="6"
                  height="4"
                  stroke-linejoin="round"
                ></rect>
              </g>
            </svg>
            <span>
              Stocks
            </span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            to="/orders"
          >
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 24 24"
              xml:space="preserve"
              width="24"
              height="24"
            >
              <g
                class="nc-icon-wrapper"
                transform="translate(0.5, 0.5)"
                fill="#ffffff"
              >
                <polyline
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  points="20,4 22,4 22,23 2,23 2,4 4,4 "
                  stroke-linejoin="round"
                ></polyline>
                <path
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  d="M14,3c0-1.105-0.895-2-2-2 s-2,0.895-2,2H7v4h10V3H14z"
                  stroke-linejoin="round"
                ></path>
                <line
                  data-color="color-2"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  x1="7"
                  y1="11"
                  x2="17"
                  y2="11"
                  stroke-linejoin="round"
                ></line>
                <line
                  data-color="color-2"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  x1="7"
                  y1="15"
                  x2="17"
                  y2="15"
                  stroke-linejoin="round"
                ></line>
                <line
                  data-color="color-2"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  x1="7"
                  y1="19"
                  x2="11"
                  y2="19"
                  stroke-linejoin="round"
                ></line>
              </g>
            </svg>
            <span>
              Pedidos
            </span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            to="/supply-orders"
          >
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 24 24"
              xml:space="preserve"
              width="24"
              height="24"
            >
              <g
                class="nc-icon-wrapper"
                transform="translate(0.5, 0.5)"
                fill="#ffffff"
              >
                <circle
                  data-color="color-2"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  cx="7"
                  cy="21"
                  r="2"
                  stroke-linejoin="round"
                ></circle>
                <circle
                  data-color="color-2"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  cx="19"
                  cy="21"
                  r="2"
                  stroke-linejoin="round"
                ></circle>
                <polyline
                  data-cap="butt"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-miterlimit="10"
                  points="4.667,6 22,6 20,16 6,16 4,1 1,1 "
                  stroke-linejoin="round"
                  stroke-linecap="round"
                ></polyline>
              </g>
            </svg>
            <span>
              Compras
            </span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            to="/barcode"
          >
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 24 24"
              xml:space="preserve"
              width="24"
              height="24"
            >
              <g
                class="nc-icon-wrapper"
                transform="translate(0.5, 0.5)"
                fill="#ffffff"
              >
                <polygon
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  points="10,10 1,10 1,1 10,1 10,1 "
                  stroke-linejoin="round"
                ></polygon>
                <polygon
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  points="23,10 14,10 14,1 14,1 23,1 "
                  stroke-linejoin="round"
                ></polygon>
                <polygon
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  points="10,23 1,23 1,14 10,14 10,14 "
                  stroke-linejoin="round"
                ></polygon>
                <polyline
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  points="23,19 23,14 19,14 19,17 15,17 15,14 "
                  stroke-linejoin="round"
                ></polyline>
                <polyline
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  points="23,23 15,23 15,21 "
                  stroke-linejoin="round"
                ></polyline>
                <polygon
                  data-color="color-2"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  points=" 6,6 5,6 5,5 6,5 6,6 "
                  stroke-linejoin="round"
                ></polygon>
                <polygon
                  data-color="color-2"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  points=" 19,6 18,6 18,6 18,5 19,5 "
                  stroke-linejoin="round"
                ></polygon>
                <polygon
                  data-color="color-2"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  points=" 6,19 5,19 5,18 6,18 6,19 "
                  stroke-linejoin="round"
                ></polygon>
              </g>
            </svg>
            <span>Código Barras</span>
          </router-link>
        </li>
        <li class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="navbarDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 24 24"
              xml:space="preserve"
              width="24"
              height="24"
            >
              <g
                class="nc-icon-wrapper"
                fill="#ffffff"
                transform="translate(0.5, 0.5)"
              >
                <polyline
                  data-color="color-2"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="square"
                  stroke-miterlimit="10"
                  points=" 2,16 2,22 22,22 22,16 "
                  stroke-linejoin="miter"
                ></polyline>
                <line
                  data-cap="butt"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-miterlimit="10"
                  x1="12"
                  y1="17"
                  x2="12"
                  y2="2"
                  stroke-linejoin="miter"
                  stroke-linecap="butt"
                ></line>
                <polyline
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="square"
                  stroke-miterlimit="10"
                  points="18,8 12,2 6,8 "
                  stroke-linejoin="miter"
                ></polyline>
              </g>
            </svg>
            <span>
              Guias CTT
            </span>
          </a>
          <div
            class="dropdown-menu"
            aria-labelledby="navbarDropdown"
          >
            <router-link
              class="dropdown-item"
              to="/transport-label-list/"
            >Lista de Guias</router-link>
            <router-link
              class="dropdown-item"
              to="/transport-label/new"
            > Nova Guia CTT </router-link>
          </div>
        </li>
      </ul>
      <div class="user">
        <div class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="navbarDropdownMenuLink"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <svg
              v-if="user.name == null"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 24 24"
              xml:space="preserve"
              width="24"
              height="24"
            >
              <g
                class="nc-icon-wrapper"
                fill="#ffffff"
                transform="translate(0.5, 0.5)"
              >
                <path
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="square"
                  stroke-miterlimit="10"
                  d="M12,1L12,1 C9.2,1,7,3.2,7,6v3h10V6C17,3.2,14.8,1,12,1z"
                  stroke-linejoin="miter"
                ></path>
                <rect
                  x="4"
                  y="9"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="square"
                  stroke-miterlimit="10"
                  width="16"
                  height="14"
                  stroke-linejoin="miter"
                ></rect>
                <circle
                  data-color="color-2"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="square"
                  stroke-miterlimit="10"
                  cx="12"
                  cy="15"
                  r="2"
                  stroke-linejoin="miter"
                ></circle>
                <line
                  data-color="color-2"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1"
                  stroke-linecap="square"
                  stroke-miterlimit="10"
                  x1="12"
                  y1="17"
                  x2="12"
                  y2="19"
                  stroke-linejoin="miter"
                ></line>
              </g>
            </svg>
            <img
              width="25px"
              height="25px"
              class="rounded-circle"
              :src="user.gravatar"
              v-if="user.name !== null"
            >
            <span>{{user.name}}</span>
          </a>
          <div
            class="dropdown-menu"
            aria-labelledby="navbarDropdownMenuLink"
          >
            <router-link
              class="dropdown-item"
              v-show="user.email == null"
              to="/login"
            >Login</router-link>
            <a
              class="dropdown-item"
              v-show="user.email !== null"
              @click.prevent="onLogout"
            >Logout</a>
            <a
              class="dropdown-item"
              href="https://api.ohjoy.pt/graphql"
              target="_blank"
            >Graphiql</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
</style>


<script>
import jwtDecode from "jwt-decode";
import LoginService from "../../services/LoginService";
import { mapState } from "vuex";

export default {
  created() {
    this.loginService = new LoginService();
  },
  computed: mapState({
    showMenu: state => state.showMenu,
    showSidebar: state => state.showSidebar,
    user: state => state.user
  }),
  data() {
    return {
      msg: "Welcome to Your Vue.js App"
    };
  },
  mounted() {},
  methods: {
    onLogout() {
      this.loginService.logout();
      this.$store.commit("removeUser");
      this.$router.replace("/login");
    },
    toggleMenu() {
      this.$store.commit("toggleShowMenu");
    }
  }
};
</script>



// WEBPACK FOOTER //
// Sidebar.vue?6a868d68